import { catalogOperationsClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type {
  CatalogOperationsProgressDto,
  RestartFromStagePayload,
  RestartFromStageResponse,
  StageDecisionPayload,
  StageDecisionResponse,
  TriggerFeedAuditPayload,
  TriggerFeedAuditResponse,
} from '../types/feed-audit.types';

/**
 * Triggers a FEED_AUDIT catalog-operations run. Returns immediately; the run
 * progresses asynchronously — persist `workflowId` (progress) and `jobId` (detail).
 */
export async function triggerFeedAudit(
  payload: TriggerFeedAuditPayload,
): Promise<TriggerFeedAuditResponse> {
  return catalogOperationsClient
    .post(endpoints.catalogOperationsWorkflow.trigger(), { json: payload })
    .json<TriggerFeedAuditResponse>();
}

/** Fetches the hybrid progress snapshot (stage statuses + open gate) for a run. */
export async function getFeedAuditProgress(
  workflowId: string,
): Promise<CatalogOperationsProgressDto> {
  return catalogOperationsClient
    .get(endpoints.catalogOperationsWorkflow.progress(workflowId))
    .json<CatalogOperationsProgressDto>();
}

/** Submits the operator's gate decision (APPROVE/REJECT/…) for a paused run. */
export async function submitStageDecision(
  workflowId: string,
  payload: StageDecisionPayload,
): Promise<StageDecisionResponse> {
  return catalogOperationsClient
    .post(endpoints.catalogOperationsWorkflow.stageDecision(workflowId), { json: payload })
    .json<StageDecisionResponse>();
}

/** Restarts a failed run from a chosen pipeline stage, reusing prior-stage results. */
export async function restartFeedAuditFromStage(
  workflowId: string,
  payload: RestartFromStagePayload,
): Promise<RestartFromStageResponse> {
  return catalogOperationsClient
    .post(endpoints.catalogOperationsWorkflow.restartFromStage(workflowId), { json: payload })
    .json<RestartFromStageResponse>();
}
